export default __webpack_public_path__ + "static/stones-0eedb3b0d80c69c516f3cb3d6d35a0eb.png";